import { render, staticRenderFns } from "./integralBox.vue?vue&type=template&id=d1834e5e&scoped=true&"
import script from "./integralBox.vue?vue&type=script&lang=js&"
export * from "./integralBox.vue?vue&type=script&lang=js&"
import style0 from "./integralBox.vue?vue&type=style&index=0&id=d1834e5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1834e5e",
  null
  
)

export default component.exports